<template>
  <v-dialog v-model="show" max-width="800px" persistent scrollable>
    <v-card>
      <v-card-text v-if="formValues" style='height:1500px'>
        <v-card-title mt-2 style="justify-content: center;">{{ $t('subOrder.formValues.title') }} {{ title }}</v-card-title>
        <validation-observer ref="form">
          <v-form>
            <span class="text-caption font-weight-thin">* {{ $t('pickingForm.requiredFields') }}</span>
            <v-col cols="12">
              <v-select
                  v-model="formValues.civility"
                  :items="civilityItems"
                  :label="$t('pickingForm.civility')"
                  class="mt-4"
                  clearable
                  dense
              ></v-select>
              <validation-provider v-slot="{ errors }" :name="$t('pickingForm.firstName')" rules="required">
                <v-text-field
                    v-model="formValues.first_name"
                    :error-messages="errors"
                    :label="$t('pickingForm.firstName')"
                    class="required"
                    clearable
                    required
                >
                </v-text-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }" :name="$t('pickingForm.lastName')" rules="required">
                <v-text-field
                    v-model="formValues.last_name"
                    :error-messages="errors"
                    :label="$t('pickingForm.lastName')"
                    class="required"
                    clearable
                    required
                >
                </v-text-field>
              </validation-provider>
              <validation-provider  v-slot="{ errors }" :name="$t('pickingForm.street1')" rules="required">
                <v-text-field
                    v-model="formValues.street_1"
                    :error-messages="errors"
                    :label="$t('pickingForm.street1')"
                    class="required"
                    clearable
                    required
                >
                </v-text-field>
              </validation-provider>
              <template >
              <v-text-field
                  v-model="formValues.street_2"
                  :label="$t('pickingForm.street2')"
                  clearable
              >
              </v-text-field>
              <v-text-field
                  v-model="formValues.street_3"
                  :label="$t('pickingForm.street3')"
                  clearable
              >
              </v-text-field>
              <v-text-field
                  v-model="formValues.postal_code"
                  :label="$t('pickingForm.postalCode')"
                  clearable
                  required
              >
              </v-text-field>
              <v-text-field
                  v-model="formValues.company"
                  :label="$t('pickingForm.company')"
                  clearable
              >
              </v-text-field>
              <validation-provider  v-slot="{ errors }" :name="$t('pickingForm.city')" rules="required">
                <v-text-field
                    v-model="formValues.city"
                    :error-messages="errors"
                    :label="$t('pickingForm.city')"
                    class="required"
                    clearable
                    required
                >
                </v-text-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }" :name="$t('pickingForm.countryCode')" rules="required">
                <CountriesAutocomplete v-model="formValues.country_code" :errorMessage="errors" :required="true" item-text="name" @update="updateCountryCode"/>
              </validation-provider>
              </template>
              <vue-tel-input-vuetify
                  ref="phone"
                  v-model="formValues.phone"
                  :defaultCountry="getDefaultCountry(formValues.country_code)"
                  :disabledFetchingCountry="true"
                  :error-messages="phoneError"
                  :placeholder="$t('pickingForm.phone')"
                  class="mt-1"
                  clearable
                  label=""
                  mode="international"
                  @input="validatePhone"
              />
            </v-col>
          </v-form>
        </validation-observer>
      </v-card-text>
      <v-card-actions class="pa-0 mt-2">
        <v-btn
            color="primary"
            style="width: 50%"
            tile
            @click="onSubmit"
        >
          {{ $t('pickingForm.validate') }}
        </v-btn>
        <v-btn
            class="ml-0"
            color="secondary"
            style="width: 50%"
            tile
            @click="close">
          {{ $t('pickingForm.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import CountriesAutocomplete from '@/components/CountriesAutocomplete'
import isoCountries from 'i18n-iso-countries'

export default {
  name: 'AddressDialog',
  props: {
    formValue: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    value: {
      type: Boolean,
      default: false
    },
    addressType: {
      type: String,
      required: true
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    CountriesAutocomplete
  },
  data () {
    return {
      formValues: null,
      phoneError: []
    }
  },
  mounted () {
    isoCountries.registerLocale(require(`i18n-iso-countries/langs/${this.$i18n.locale}.json`))
    this.formValues = Object.assign({} ,this.formValue)
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    civilityItems () {
      return [
        { text: this.$t('pickingForm.mr'), value: 'mr' },
        { text: this.$t('pickingForm.mrs'), value: 'mrs' }
      ]
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async onSubmit () {
      const success = await this.$refs.form.validate()
      const phoneIsValid = this.formValues.phone ? this.formValues.phoneIsValid : true
      if (success && phoneIsValid) {
        this.$emit('validateForm', { data: this.formValues, addressType: this.addressType })
      }
    },
    validatePhone (number, phone) {
      if (number) {
        if (phone.isValid) {
          this.phoneError = []
          this.formValues.phone = phone.number.e164
          this.formValues.phoneIsValid = true
        } else {
          this.phoneError = this.$t('pickingForm.phoneError')
          this.formValues.phoneIsValid = false
        }
      } else {
        this.formValues.phone = null
      }
    },
    getDefaultCountry (countryCode) {
      return isoCountries.alpha3ToAlpha2(countryCode)
    },
    updateCountryCode (values) {
      this.$refs.phone.choose({ iso2: this.getDefaultCountry(values) })
    }
  }
}
</script>
